import React, {Component} from 'react';
import PropTypes from "prop-types";

class ModuleNav extends Component {

    static propTypes = {
        activeView: PropTypes.string.isRequired,
        translate: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    static defaultProps = {
        views: 'table medium small',    //  verticalsep
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: 'smallView',
        };

        this.translate = this.props.translate;

    }

    getElements() {

        let views = this.props.views.split(" ").reverse();

        return views.map(
            (view,index) => {
                if (view !== '' && view !== false && view !== null && view !== undefined) {
                    if (view === 'verticalsep') {
                        return {
                            eleIndex: 'view-' + index,
                            eleType: 'verticalsep',
                            eleClasses: 'webElement',
                        };
                    } else {
                        let lowerView = view.toLowerCase();
                        let upperView = view.charAt(0).toUpperCase() + view.slice(1);

                        return {
                            eleIndex: 'view-' + index,
                            eleName: this.translate(lowerView + 'View'),
                            eleActive: lowerView + 'View',
                        };
                    }
                }
            }
        );

    }

    renderElement(element) {

        if (element !== '' && element !== false && element !== null && element !== undefined) {
            if (element.eleType === 'verticalsep') {
                let classes = ['verticalsep', element.eleClasses].join(' ').trim();

                return <i key={element.eleIndex} className={classes}>|</i>
            } else {
                let spanClasses = ['moduletip hint--bottom hint--modcustom', 'rightside', (element.eleClasses) ? element.eleClasses : ''].join(' ').trim();
                let iconClasses = ['modulecustomizer', element.eleActive, (this.props.activeView === element.eleActive ? ' active' : '')].join(' ').trim();

                return (
                    <span key={element.eleIndex} className={spanClasses} onClick={() => this.props.onClick(element.eleActive)}
                          data-hint={element.eleName}>
                        <i className={iconClasses}
                             id={element.eleActive}>
                             {element.eleName}
                        </i>
                    </span>
                );
            }
        }

    }

    render() {

        let elements = this.getElements();

        return (
            <span className={"moduleNav"}>
                <span className={"clearfix"}>
                    {elements.map(
                        (element) => this.renderElement(element)
                    )}
                </span>
            </span>
        );

    }

}

export default ModuleNav;